import { Base } from './base';

export class Fine extends Base {
    FineID?: string;
    AuthorID?: string;
    CompanyID?: number;
    FinePriceID?: number;
    ParkingID?: number;
    ParkingLotID?: number;
    PaymentID?: string;
    PublicInstitutionID?: number;
    VehicleID?: string;
    FineStatID?: number;
    Amount?: string;
    Date?: Date;
    Description?: string;
    IsNotified?: boolean;
    Title?: string;

    // Model properties
    Address?: string;
    AuthorEmail?: string;
    AuthorName?: string;
    AuthorPhone?: string;
    Avatar?: string;
    Company?: string;
    Location?: string;
    Parking?: string;
    Pictures?: Array<string>;
    Plate?: string;
    No?: number;
    PvNote?: string;
    Note?: string;
    VehicleType?: string;
    VehicleColor?: string;
    ParkingName?: string;
    CheckDate?: Date;

    // Web properties
    FineStat?: string;
}
